import Toggle from 'legacy/common/components/form/Toggle';
import InfoTooltip from 'legacy/common/components/wysiwyg-form/InfoTooltip';
import { useFormikContext } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

const Guests = () => {
  const { values, setFieldValue } = useFormikContext<any>();
  const { t } = useTranslation(['events', 'common']);
  const togglePrivacy = () => {
    setFieldValue('showGuests', !values.showGuests);
  };

  return (
    <div className="mt-6 p-4 border-1 rounded-md">
      <div className="flex flex-col justify-center">
        <div className="text-lg font-semibold">
          {t('events:eventDetails.guestList')}
        </div>

        {(values.isDraft ||
          values.isDraft === undefined ||
          values.isDraft === null) && (
          <div className="text-sm text-gray-400 font-normal">
            {t('events:host.inviteGuests')}
          </div>
        )}
      </div>

      <div className="w-full mt-4 mr-10 text-base text-gray-500 flex items-center justify-between">
        <div className="text-base font-normal flex items-center">
          {t('common:buttons.hide')}
          <InfoTooltip
            id="hide-tooltip"
            message={t('events:host.hideTooltip')}
          />
        </div>
        <Toggle isActive={!values.showGuests} onClick={togglePrivacy} />
      </div>
    </div>
  );
};

export default Guests;
